import * as React from 'react';
import { Box, Button, Chip, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getOfferDetailsAsync } from './OfferStore/offerStoreSlice';
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import useStyles from '../../ApprovalManagement/ConfirmAdmissionScreen/styles/leadDetails';
import { useState } from 'react';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import { usersColumns } from './usersColumns';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  height: 540,
  overflowY: 'scroll',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const ViewDeatils = ({ id }) => {
  const [show, setShow] = useState(true);
  const classes = useStyles();
  const dispatch = useDispatch();

  const { offerDetails, daysRemaining } = useSelector((state) => {
    const { offerReducer } = state;
    return {
      offerDetails:
        offerReducer.offerDetails &&
        offerReducer.offerDetails.data &&
        offerReducer.offerDetails.data.fetchedOffer[0],
      daysRemaining:
        offerReducer.offerDetails &&
        offerReducer.offerDetails.data &&
        offerReducer.offerDetails.data.daysRemaining,
    };
  });

  var today = new Date();
  var date1 = moment(today).format('YYYY-MM-DD');
  var date2 = moment(offerDetails && offerDetails.expiredAt).format(
    'YYYY-MM-DD'
  );

  React.useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    try {
      dispatch(getOfferDetailsAsync(id))
        .unwrap()
        .then(() => {
          toast.success('All Offer Details fetched successfully.');
        });
    } catch (error) {
      toast.error(
        'Offer Details could not be fetched. Please try again later!'
      );
    }
  };

  return (
    <Box sx={style}>
      {show ? (
        <Box>
          {offerDetails ? (
            <div className={classes.seconudcontainer}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <div className={classes.leadborder}>
                    <div>
                      <div className={classes.details}>
                        <div
                          className={classes.fontleadbold}
                          style={{
                            marginBottom: '0.5rem',
                            paddingTop: '0px',
                            marginTop: '0px',
                          }}>
                          Offer Details
                        </div>
                        <div className={classes.leaddetails}>
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <div className={classes.fontlead}>Id</div>
                            </Grid>
                            <Grid item xs={8}>
                              <div className={classes.fontanswer}>
                                {offerDetails._id}
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                        <div className={classes.leaddetails}>
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <div className={classes.fontlead}>Title</div>
                            </Grid>
                            <Grid item xs={8}>
                              <div className={classes.fontanswer}>
                                {offerDetails.title}
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                        <div className={classes.leaddetails}>
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <div className={classes.fontlead}>Amount</div>
                            </Grid>
                            <Grid item xs={8}>
                              <div className={classes.fontanswer}>
                                {offerDetails.amount}%
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                        <div className={classes.leaddetails}>
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <div className={classes.fontlead}>Status</div>
                            </Grid>
                            <Grid item xs={8}>
                              <div className={classes.fontanswer}>
                                {offerDetails.status}
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                        <div className={classes.leaddetails}>
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <div className={classes.fontlead}>Type</div>
                            </Grid>
                            <Grid item xs={8}>
                              <div className={classes.fontanswer}>
                                {offerDetails.type}
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                        <div className={classes.leaddetails}>
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <div className={classes.fontlead}>Domain</div>
                            </Grid>
                            <Grid item xs={8}>
                              <div className={classes.fontanswer}>
                                {offerDetails.domain}
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                        <div className={classes.leaddetails}>
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <div className={classes.fontlead}>Code</div>
                            </Grid>
                            <Grid item xs={8}>
                              <div className={classes.fontanswer}>
                                {offerDetails.code}
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                        {offerDetails.users[0] && (
                          <div className={classes.leaddetails}>
                            <Grid container spacing={3}>
                              <Grid item xs={4}>
                                <div className={classes.fontlead}>Users</div>
                              </Grid>
                              <Grid item xs={8}>
                                <Button
                                  variant="contained"
                                  onClick={(e) => setShow(false)}>
                                  View all Users
                                </Button>
                              </Grid>
                            </Grid>
                          </div>
                        )}
                        {offerDetails.emailIds && (
                          <div className={classes.leaddetails}>
                            <Grid container spacing={3}>
                              <Grid item xs={4}>
                                <div className={classes.fontlead}>Users</div>
                              </Grid>
                              <Grid item xs={8}>
                                <div className={classes.fontanswer}>
                                  {offerDetails.emailIds.join(', ')}
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        )}
                        {offerDetails.courses[0] && (
                          <div className={classes.leaddetails}>
                            <Grid container spacing={3}>
                              <Grid item xs={4}>
                                <div className={classes.fontlead}>Courses</div>
                              </Grid>
                              <Grid item xs={8}>
                                <div className={classes.fontanswer}>
                                  {offerDetails.courses.map((course) => (
                                    <Chip label={course.title} />
                                  ))}
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        )}
                        <div className={classes.leaddetails}>
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <div className={classes.fontlead}>Expired At</div>
                            </Grid>
                            <Grid item xs={8}>
                              <div className={classes.fontanswer}>
                                {date1 <= date2 ? (
                                  <Box>
                                    {moment(offerDetails.expiredAt).format(
                                      'MMMM Do, YYYY'
                                    )}
                                  </Box>
                                ) : (
                                  <Box
                                    sx={{
                                      color: '#A30000',
                                      fontWeight: 'bold',
                                    }}>
                                    {moment(offerDetails.expiredAt).format(
                                      'MMMM Do, YYYY'
                                    )}
                                  </Box>
                                )}
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                        <div className={classes.leaddetails}>
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <div className={classes.fontlead}>
                                Remaining Days
                              </div>
                            </Grid>
                            <Grid item xs={8}>
                              <div className={classes.fontanswer}>
                                {daysRemaining} Days
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                        <div className={classes.leaddetails}>
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <div className={classes.fontlead}>Created At</div>
                            </Grid>
                            <Grid item xs={8}>
                              <div className={classes.fontanswer}>
                                {moment(offerDetails.createdAt).format(
                                  'MMMM Do, YYYY'
                                )}
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                        <div>
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <div className={classes.fontlead}>Updated At</div>
                            </Grid>
                            <Grid item xs={8}>
                              <div className={classes.fontanswer}>
                                {moment(offerDetails.updatedAt).format(
                                  'MMMM Do, YYYY'
                                )}
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          ) : null}
        </Box>
      ) : (
        <>
          <Box display="flex">
            <Box flex={1}>
              <Typography>List of Users</Typography>
            </Box>
            <Box flex={1} textAlign={'right'}>
              <Button
                variant="contained"
                onClick={() => setShow(true)}
                color="primary">
                Back
              </Button>
            </Box>
          </Box>
          <Box mt={2}>
            <BuzzTable
              columns={usersColumns}
              data={offerDetails && offerDetails.users}
            />
          </Box>
        </>
      )}
    </Box>
  );
};

export default ViewDeatils;
